import { ComponentType } from '../validators/fields/ComponentType';
import { FileUpload } from './File';

import { Battery } from '../validators/components/Battery';
import { Bus } from '../validators/components/Bus';
import { Capacitor } from '../validators/components/Capacitor';
import { Charger } from '../validators/components/Charger';
import { CircuitBreaker } from '../validators/components/CircuitBreaker';
import { CombinerBox } from '../validators/components/CombinerBox';
import { Contactor } from '../validators/components/Contactor';
import { Converter } from '../validators/components/Converter';
import { Custom } from '../validators/components/Custom';
import { Diode } from '../validators/components/Diode';
import { Disconnect } from '../validators/components/Disconnect';
import { FuelCell } from '../validators/components/FuelCell';
import { Fuse } from '../validators/components/Fuse';
import { Generator } from '../validators/components/Generator';
import { Grounding } from '../validators/components/Grounding';
import { HVAC } from '../validators/components/HVAC';
import { Hydro } from '../validators/components/Hydro';
import { Load } from '../validators/components/Load';
import { Light } from '../validators/components/Light';
import { Meter } from '../validators/components/Meter';
import { Motor } from '../validators/components/Motor';
import { Other } from '../validators/components/Other';
import { Panel } from '../validators/components/Panel';
import { PowerDistributionUnit } from '../validators/components/PowerDistributionUnit';
import { Precharge } from '../validators/components/Precharge';
import { Connector } from '../validators/components/Connector';
import { RapidShutdownDevice } from '../validators/components/RapidShutdownDevice';
import { Reference } from '../validators/components/Reference';
import { Solar } from '../validators/components/Solar';
import { Display } from '../validators';
import { FileVisibility } from '../validators/component-sections/files';
import { Solution } from '../validators/components/Solution';
import { CurrentTransducer } from '../validators/components/CurrentTransducer';
import { VoltageTransducer } from '../validators/components/VoltageTransducer';
import { TransferSwitch } from '../validators/components/TransferSwitch';
import { Transformer } from '../validators/components/Transformer';
import { Utility } from '../validators/components/Utility';
import { Wind } from '../validators/components/Wind';
import { Cable } from '../validators/components/Cable';
import { Controller } from '../validators/components/Controller';
import { Software } from '../validators/components/Software';

export type Component =
    | Battery
    | Bus
    | Capacitor
    | Charger
    | CircuitBreaker
    | CombinerBox
    | Contactor
    | Converter
    | CurrentTransducer
    | Custom
    | Diode
    | Disconnect
    | FuelCell
    | Fuse
    | Generator
    | Grounding
    | HVAC
    | Hydro
    | Load
    | Light
    | Meter
    | Motor
    | Other
    | Panel
    | Connector
    | PowerDistributionUnit
    | Precharge
    | RapidShutdownDevice
    | Reference
    | Solar
    | Solution
    | TransferSwitch
    | Transformer
    | Utility
    | VoltageTransducer
    | Wind
    | Cable
    | Controller
    | Software;

export {
    Display as ComponentFieldDisplay,
    DisplayLabels as ComponentFieldDisplayLabels,
} from '../validators/component-sections/metadata';

export type { FieldMeta as ComponentFieldMeta } from '../validators/component-sections/metadata';

export type ComponentTeaser = Component;
export type ComponentCount = { [key in ComponentType]: number };
export type ComponentFileUpload = FileUpload & {
    type: string;
    visibility?: FileVisibility;
};

export const isAlternativeDisplay = (
    display?: Display,
): display is Display.NOT_APPLICABLE | Display.HIDDEN | Display.UNKNOWN => {
    switch (display) {
        case Display.NOT_APPLICABLE:
        case Display.HIDDEN:
        case Display.UNKNOWN:
            return true;

        default:
            return false;
    }
};
